import styled from 'styled-components';
import C from '@assets/themes/colors';

interface IRootProps {
  flex?: Boolean;
  top?: string;
  float?: Boolean;
}

export const Root = styled.div`
  height: ${(props: IRootProps) => props.top && 'calc(100% - '+props.top+')'};
  width: 100%;
  overflow-x: hidden;
  overflow-y: scroll;
  position: relative;
  border-radius: 5px;
  box-shadow: 4px 4px 20px 2px rgba(0, 0, 0, 0.05);
  background-color: #ffffff;
  .group-list {
    display: ${(props: IRootProps) => props.flex ? 'grid' : 'unset'};
    grid-template-columns: ${(props: IRootProps) => props.flex ? 'repeat(auto-fill, 230px)' : 'unset'};
    justify-content: ${(props: IRootProps) => props.flex ? 'space-between' : 'unset'};
  }
  .infinite-scroll-component__outerdiv{
    height: 100%;
  }
`;

export const Container = styled.div`
  position: relative;
`

export const TypeContainer = styled.div`
  overflow-x: hidden;
  overflow-y: hidden;
`

export const ListEmty = styled.div`
  padding: 5%  15%;
  text-align: center;  
`

export const Text = styled.div`
  height: 45px;
  width:100%;
  padding: 20px 0px;
  text-align:center;
  font-size: 20px;
  font-weight: normal;
  color: #122442;
  display: inline-block;
`;

export const Tittle = styled.label`
  font-family: Roboto;
  font-size: 30px;
  font-weight: 500;
  text-align: left;
  color: #204078;
  display:block;
`;

export const SubTittle = styled.label`
  margin: 29px 0 8%;
  font-family: Roboto;
  font-size: 18px;
  font-weight: normal;
  text-align: left;
  color: #122442;
  display:block;
`;

export const Result = styled.div`
  margin: 40px 25px 25px 39px;
  font-size: 25px;
  font-weight: normal;
  color: ${C.DARK_BLUE};
`;
export const Counter = styled.span`
    font-size: 15px;
    font-weight: normal;
    color: #8891a0;
    margin-left: 24px;
`;

export const Orderby = styled.span`
  font-size: 15px;
  font-weight: normal;
  color: #8891a0;
  float:  ${(props: IRootProps) => props.float && 'right'};
  display:  ${(props: IRootProps) => !props.float && 'block'};
  position: ${(props: IRootProps) => !props.float && 'absolute'};
  right: ${(props: IRootProps) => !props.float && '0'};
  padding: ${(props: IRootProps) => !props.float && '6px 10px'};
`;